import { TreeItem } from '@rbb/ng-web-template-lib';

export class AdminEmployeeListItem {
  id: string | undefined;
  name: string | undefined;
  sap: boolean | undefined;
  username: string | undefined;
  uidNumber: string | undefined;

  static toTreeItem(adminEmployeeListItem: AdminEmployeeListItem): TreeItem {
    return {
      name: adminEmployeeListItem.name,
      children: [],
      object: adminEmployeeListItem,
      item: true
    };
  }
}
